<div class="container-fluid">
  <page-header-search
    [isSearchInput]="false"
    [pageTitleValue]="pageTitle"
  ></page-header-search>
  <div class="card mb-4">
    <div class="card-body">
      <form
        [formGroup]="pushNotificationForm"
        (ngSubmit)="onPushNotificationSubmit()"
      >
        <div class="row mb-5">
          <div class="col d-flex align-items-center">
            <label class="mr-6 mb-0" for="covid-check"
              >is Doctor Notification</label
            >
            <label class="custom-toggle custom-toggle-default">
              <input
                checked="checked"
                type="checkbox"
                id="covid-check"
                formControlName="isDoctorNotification"
              />
              <span
                class="custom-toggle-slider rounded-circle"
                data-label-off="No"
                data-label-on="Yes"
              >
              </span>
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="pn-title">
                Push Notification Title
              </label>
              <input
                class="form-control"
                id="pn-title"
                formControlName="notificationTitle"
                placeholder="Push Notification Title"
                type="text"
              />
              <div
                *ngIf="
                  (isSubmited ||
                    pushNotificationForm.controls.notificationTitle.dirty) &&
                  pushNotificationForm.controls.notificationTitle.errors
                "
                class="input-errors"
              >
                <p
                  *ngIf="
                    pushNotificationForm.controls.notificationTitle.errors
                      .required
                  "
                >
                  This field is required!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="pn-body">
                Push Notification Body
              </label>
              <input
                class="form-control"
                id="pn-body"
                formControlName="notificationBody"
                placeholder="Push Notification Body"
                type="text"
              />
              <div
                *ngIf="
                  (isSubmited ||
                    pushNotificationForm.controls.notificationBody.dirty) &&
                  pushNotificationForm.controls.notificationBody.errors
                "
                class="input-errors"
              >
                <p
                  *ngIf="
                    pushNotificationForm.controls.notificationBody.errors
                      .required
                  "
                >
                  This field is required!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="sound">
                Choose the Sound
              </label>
              <select
                formControlName="notificationSound"
                class="form-control"
                id="sound"
              >
                <option *ngFor="let sound of sounds" [value]="sound.id">
                  {{ sound.label }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="gender">
                Choose Gender
              </label>
              <select
                formControlName="notificationGender"
                class="form-control"
                id="gender"
              >
                <option *ngFor="let gender of genderList" [value]="gender.id">
                  {{ gender.label }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="route">
                Choose the Route
              </label>
              <select
                formControlName="notificationRoute"
                class="form-control"
                id="route"
                (change)="routeChanged($event.target.value)"
              >
                <option *ngFor="let route of routes" [value]="route.id">
                  {{ route.pageName }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-6" *ngIf="specificRoute">
            <div class="form-group">
              <label class="form-control-label" for="offer-route">
                Choose the Id of specific Route
              </label>
              <input
                class="form-control"
                id="offer-name"
                formControlName="notificationSpecificRoute"
                placeholder="specific Route"
                type="text"
              />
            </div>
          </div>
        </div>
        <div
          class="row"
          *ngIf="pushNotificationForm.controls.isDoctorNotification.value"
        >
          <div class="col-md-6">
            <div class="form-group">
              <label class="filter-control-label" for="Specialty">
                Specialty
              </label>
              <ng-multiselect-dropdown
                [placeholder]="'Select Specialties'"
                [settings]="dropdownSettings"
                [data]="dropdownList"
                formControlName="notificationSpecialties"
                name="multi-select"
              >
                >
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <div class="form-group">
                <label class="form-control-label" for="type">
                  Doctor Type
                </label>
                <select
                  formControlName="notificationDoctorType"
                  class="form-control"
                  id="type"
                >
                  <option
                    *ngFor="let item of doctorTypes; let i = index"
                    [value]="item.id"
                  >
                    {{ item.type }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label"> Age Range </label>
              <input
                type="text"
                class="form-control"
                bsDaterangepicker
                formControlName="notificationDateRange"
                [bsConfig]="{
                  isAnimated: true,
                  containerClass: 'theme-blue'
                }"
                name="bsDaterangepicker"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="filter-control-label" for="Specialty">
                Cities
              </label>
              <ng-multiselect-dropdown
                [placeholder]="'Select Cities'"
                [settings]="dropdownSettings"
                [data]="cities"
                formControlName="notificationCities"
                name="multi-select"
              >
                >
              </ng-multiselect-dropdown>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col btns-block">
            <button
              class="btn btn-primary"
              type="submit"
              [disabled]="pushNotificationForm.invalid"
            >
              {{ "Send" }}
            </button>
            <button
              class="btn btn-outline-danger"
              type="button"
              [routerLink]="'/offers'"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<ngx-spinner></ngx-spinner>
